import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Target, Archive, Trophy, MessageCircle, Shield, ChevronDown, FolderDown, Users, Newspaper } from 'lucide-react'
import clsx from 'clsx'
import { mockChannels } from '../../data/mock'
import { apiUrl } from '../../config/api'
import useOrg from '../../hooks/useOrg'
import type { Channel } from '../../types'

const iconMap: Record<string, React.ComponentType<{ size?: number }>> = {
  Target,
  Archive,
  FolderDown,
  Trophy,
  MessageCircle,
  Shield,
  Users,
  Newspaper,
}

interface ChannelListProps {
  onChannelClick?: () => void
}

export default function ChannelList({ onChannelClick }: ChannelListProps) {
  const org = useOrg()
  const { slug, channel } = useParams()
  const navigate = useNavigate()
  const [missionsCount, setMissionsCount] = useState(0)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) return
    fetch(apiUrl('/v1/community/missions?status=active&per_page=1'), {
      headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.meta?.total) setMissionsCount(d.meta.total) })
      .catch(() => {})
  }, [])

  const handleChannelClick = (ch: Channel) => {
    navigate(`/${slug}/${ch.slug}`)
    onChannelClick?.()
  }

  return (
    <div className="w-channel h-full bg-[#F2F3F5] flex flex-col text-[#2E3035]">
      {/* Header da Org */}
      <div className="h-12 px-4 flex items-center border-b border-black/5 hover:bg-black/5 transition-colors cursor-pointer">
        <h2 className="text-base font-semibold text-[#2E3035] truncate flex-1">
          {org.appName}
        </h2>
        <ChevronDown size={16} className="text-[#8E9297]" />
      </div>

      {/* Ações */}
      <div className="flex-1 overflow-y-auto scrollbar-thin px-2 pt-4">
        <p className="px-2 mb-1 text-xs font-semibold text-[#8E9297] uppercase tracking-wide">
          Ações
        </p>
        <nav className="flex flex-col gap-0.5">
          {mockChannels.filter(ch => ch.type !== 'contacts' || localStorage.getItem('is_leader') === 'true').map((ch) => {
            const Icon = iconMap[ch.icon] || MessageCircle
            const isActive = channel === ch.slug
            return (
              <button
                key={ch.id}
                onClick={() => handleChannelClick(ch)}
                className={clsx(
                  'flex items-center gap-2 px-2 py-1.5 rounded-md text-sm transition-colors w-full text-left',
                  isActive
                    ? 'bg-black/10 text-[#2E3035] font-semibold'
                    : 'text-[#6D6F78] hover:bg-black/5 hover:text-[#2E3035]',
                )}
              >
                <Icon size={18} />
                <span className="flex-1 truncate">{ch.name}</span>
                {ch.slug === 'missoes' && missionsCount > 0 && (
                  <span className="min-w-[20px] h-5 flex items-center justify-center rounded-full bg-primary text-white text-xs font-bold px-1.5">
                    {missionsCount}
                  </span>
                )}
              </button>
            )
          })}
        </nav>

      </div>

    </div>
  )
}
